export default __webpack_public_path__ + "static/media/banner-desktop.617c5ba4.png";